
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { UserCoin } from "@/types/profile";

interface CoinsListProps {
  isLoading: boolean;
  coins: UserCoin[];
  emptyMessage?: string;
}

const CoinsList = ({ isLoading, coins, emptyMessage = "No coins created yet" }: CoinsListProps) => {
  if (isLoading) {
    return (
      <div className="text-center text-muted-foreground py-12">
        Loading...
      </div>
    );
  }

  if (coins.length === 0) {
    return (
      <div className="text-center text-muted-foreground py-12">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {coins.map((coin) => (
        <Card key={coin.id} className="overflow-hidden">
          <CardHeader className="pb-2">
            <CardTitle className="flex justify-between items-center">
              <span>{coin.name}</span>
              <span className="text-sm bg-primary/10 px-2 py-1 rounded-full">
                {coin.symbol}
              </span>
            </CardTitle>
            <CardDescription className="truncate">
              {coin.contract_address}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground line-clamp-2">
              {coin.description || "No description provided"}
            </p>
          </CardContent>
          <CardFooter>
            <Button 
              variant="outline" 
              size="sm"
              className="w-full"
              onClick={() => window.location.href = `/coins/${coin.id}`}
            >
              View Details
            </Button>
          </CardFooter>
        </Card>
      ))}
    </div>
  );
};

export default CoinsList;
